import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';

const initialState = {
  isLogin: false,
  currentUser: {},
  notification: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
      state.isLogin = true;
    },
    setToast(state, action) {
      state.notification = action.payload;
    }
  },
});

export const LoginApi = (values) => async (dispatch) => {
  console.log(process.env.REACT_APP_BASE_URL, "hdfashdfghjsa");

  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/login`, values)
    .then((res) => {
      console.log(res, "fsdfff")
      dispatch(setCurrentUser(res?.data));
      localStorage.setItem('token',JSON.stringify(res?.data?.data?.accessToken))
      localStorage.setItem('logindata',JSON.stringify(res?.data));
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))

    })
    .catch((err) => {
      console.log(err?.response, "wddss");
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })

}
export const LogoutUrl = () => async (dispatch) => {
  dispatch(setCurrentUser({}));
  // dispatch(setToast({status:"success",message:"You are Logged out successfully"}))
}

export const { setCurrentUser, setToast } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
